import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import { config } from './config'
import i18n from './localization/i18n'
import Login from './views/Login.vue'

const Profile = () => import(/* webpackChunkName: "chunk-views" */ './views/Profile.vue')
const Reports = () => import(/* webpackChunkName: "chunk-views" */ './views/Reports.vue')
const ReportDetails = () => import(/* webpackChunkName: "chunk-views" */ './views/ReportDetails.vue')
const ReportViewLog = () => import(/* webpackChunkName: "chunk-views" */ './views/ReportViewLog.vue')
const Dealers = () => import(/* webpackChunkName: "chunk-views" */ './views/Dealers.vue')
const Kkms = () => import(/* webpackChunkName: "chunk-views" */ './views/Kkm.vue')
const BlockedKkms = () => import(/* webpackChunkName: "chunk-views" */ './views/KkmBlocked.vue')
const Tickets = () => import(/* webpackChunkName: "chunk-views" */ './views/Tickets.vue')
const TicketDetails = () => import(/* webpackChunkName: "chunk-views" */ './views/TicketDetails.vue')
const MoneyPlacements = () => import(/* webpackChunkName: "chunk-views" */ './views/MoneyPlacement.vue')
const MoneyPlacementDetails = () => import(/* webpackChunkName: "chunk-views" */ './views/MoneyPlacementDetails.vue')
const Persons = () => import(/* webpackChunkName: "chunk-views" */ './views/Persons.vue')
const Audit = () => import(/* webpackChunkName: "chunk-views" */ './views/Audit.vue')
const Attributes = () => import(/* webpackChunkName: "chunk-views" */ './views/Attributes.vue')
const AddressInfo = () => import(/* webpackChunkName: "chunk-views" */ './views/AddressInfo.vue')
const Tasks = () => import(/* webpackChunkName: "chunk-views" */ './views/Tasks.vue')

const Help = () => import(/* webpackChunkName: "chunk-views" */ './views/Help.vue')
const Error = () => import(/* webpackChunkName: "chunk-views" */ './components/general/Error.vue')

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/profile'
        },
        {
            path: '/help',
            name: 'help',
            component: Help,
            meta: { title: 'menu.help' }
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: { title: 'menu.profile' }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { title: 'menu.login' }
        },
        {
            path: '/cabinet',
            name: 'cabinet',
            redirect: '/kkms',
            meta: {
                admin: false,
                dealer: true,
                inspector: false,
                operator: false,
                title: 'menu.dealerDetails'
            }
        },
        {
            path: '/kkms',
            name: 'kkms',
            component: Kkms,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: false,
                operator: false,
                title: 'menu.kkms',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/kkms/blocked',
            name: 'kkmsBlocked',
            component: BlockedKkms,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: false,
                operator: false,
                title: 'menu.kkms',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: false,
                operator: false,
                title: 'menu.reports',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/reports/:id',
            name: 'reportDetails',
            component: ReportDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: false,
                operator: false,
                title: 'menu.reportDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        to: { name: 'reports' }
                    },
                    {
                        text: 'reportName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/reports/:id/viewlog',
            name: 'reportViewLog',
            component: ReportViewLog,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: true,
                operator: false,
                title: 'menu.reportViewLog',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        to: { name: 'reports' }
                    },
                    {
                        text: 'reportName',
                        to: { name: 'reportDetails' }
                    },
                    {
                        text: 'menu.reportViewLog',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/tickets',
            name: 'tickets',
            component: Tickets,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: true,
                operator: true,
                title: 'menu.tickets',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/tickets/:id',
            name: 'ticketDetails',
            component: TicketDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: true,
                operator: true,
                title: 'menu.ticketDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        to: { name: 'tickets' }
                    },
                    {
                        text: 'ticketName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/MoneyPlacements',
            name: 'moneyPlacements',
            component: MoneyPlacements,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: true,
                operator: false,
                title: 'menu.moneyPlacements',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/MoneyPlacements/:id',
            name: 'moneyPlacementDetails',
            component: MoneyPlacementDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: true,
                operator: false,
                title: 'menu.moneyPlacementDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealerDetails',
                        to: { name: 'tickets' }
                    },
                    {
                        text: 'ticketName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers',
            name: 'dealers',
            component: Dealers,
            meta: { admin: false, dealer: false, inspector: true, operator: true, title: 'menu.dealers' }
        },
        {
            path: '/kkm',
            name: 'kkm',
            component: Kkms,
            meta: {
                inMenu: true,
                admin: false,
                dealer: false,
                inspector: false,
                operator: true,
                title: 'menu.kkms'
            }
        },
        {
            path: '/kkm/blocked',
            name: 'blockedKkms',
            component: BlockedKkms,
            meta: {
                inMenu: false,
                admin: false,
                dealer: true,
                inspector: false,
                operator: true,
                title: 'menu.blockedKkms'
            }
        },
        {
            path: '/dealers/:dealerId/kkm',
            name: 'childKkm',
            component: Kkms,
            meta: {
                inMenu: false,
                title: 'menu.kkms',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/reports',
            name: 'childReports',
            component: Reports,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                icon: 'table',
                title: 'menu.reports',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/reports/:id',
            name: 'childReportDetails',
            component: ReportDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.reportDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        to: { name: 'childReports' }
                    },
                    {
                        text: 'reportName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/reports/:id/viewlog',
            name: 'childReportViewLog',
            component: ReportViewLog,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.reportViewLog',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        to: { name: 'childReports' }
                    },
                    {
                        text: 'reportName',
                        to: { name: 'childReportDetails' }
                    },
                    {
                        text: 'menu.reportViewLog',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/tickets',
            name: 'childTickets',
            component: Tickets,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.tickets',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/tickets/:id',
            name: 'childTicketDetails',
            component: TicketDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.ticketDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        to: { name: 'childTickets' }
                    },
                    {
                        text: 'ticketName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/MoneyPlacements',
            name: 'childMoneyPlacements',
            component: MoneyPlacements,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.moneyPlacements',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        to: { name: 'childTickets' }
                    }
                ]
            }
        },
        {
            path: '/dealers/:dealerId/MoneyPlacements/:id',
            name: 'childMoneyPlacementDetails',
            component: MoneyPlacementDetails,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.moneyPlacementDetails',
                breadcrumbs: [
                    {
                        text: 'menu.dealers',
                        to: { name: 'dealers' }
                    },
                    {
                        text: 'dealerName',
                        to: { name: 'childMoneyPlacements' }
                    },
                    {
                        text: 'moneyPlacementName',
                        active: true
                    }
                ]
            }
        },
        {
            path: '/persons',
            name: 'persons',
            component: Persons,
            meta: { admin: true, dealer: false, inspector: false, operator: true, title: 'menu.persons' }
        },
        {
            path: '/audit',
            name: 'audit',
            component: Audit,
            meta: { admin: true, dealer: false, inspector: false, operator: false, title: 'menu.audit' }
        },
        {
            path: '/sysattributes',
            name: 'attributes',
            component: Attributes,
            meta: { admin: true, dealer: false, inspector: false, operator: false, title: 'menu.systemAttributes' }
        },
        {
            path: '/kkms/:kkmId/attributes',
            name: 'kkmAttributes',
            component: Attributes,
            meta: { admin: false, dealer: true, inspector: false, operator: true, isKkmAttribute: true, title: 'menu.kkmAttributes' }
        },
        {
            path: '/kkms/attributes',
            name: 'kkmsAttributes',
            component: Attributes,
            meta: { admin: true, dealer: false, inspector: false, operator: false, isKkmAttribute: true, title: 'menu.kkmAttributes' }
        },
        {
            path: '/info/address',
            name: 'addressInfo',
            component: AddressInfo,
            meta: { admin: true, dealer: false, inspector: false, operator: true, title: 'menu.addressInfo' }
        },
        {
            path: '/tasks',
            name: 'tasks',
            component: Tasks,
            meta: { 
                isMenu: false,
                admin: false, 
                dealer: true, 
                inspector: false, 
                operator: true, 
                title: 'menu.tasks' 
            }
        },
        {
            path: '/dealers/:dealerId/tasks',
            name: 'childTasks',
            component: Tasks,
            meta: {
                inMenu: false,
                admin: false,
                dealer: false,
                inspector: true,
                operator: false,
                title: 'menu.tasks'
            }
        },
        {
            path: '/error/:code',
            name: 'error',
            component: Error,
            props: true,
            meta: { title: 'errors.error' }
        },
        {
            path: '/*',
            redirect: '/error/404'
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (!store.getters.isLoggedIn && to.path !== '/login' && to.path !== '/help') {
        next('/login')
        return
    } else if (store.getters.isLoggedIn) {
        var role = store.getters.getUserRole
        if (to.path === '/login') {
            switch (role) {
            case config.role.inspector:
                next('/dealers')
                break
            case config.role.admin:
                next('/persons')
                break
            case config.role.operator:
                next('/dealers')
                break
            case config.role.dealer:
                next('/kkms')
                break
            default:
                next('/profile')
                break
            }
            return
        }
        var all = to.meta.admin === undefined && to.meta.dealer === undefined &&
            to.meta.inspector === undefined && to.meta.operator === undefined
        if (all || ((to.meta.admin && role === config.role.admin) || (to.meta.dealer && role === config.role.dealer) ||
            (to.meta.inspector && role === config.role.inspector) || (to.meta.operator && role === config.role.operator))) {
            next()
        } else {
            next({ name: 'error', params: { code: '101' } })
        }
    } else {
        next()
    }
    router.setTitle(to)
})

router.setTitle = function (to) {
    i18n.locale = store.getters.locale
    document.title = i18n.t(to.meta.title) || 'АРМ'
}

router.getMenu = function (customRole) {
    var menu = []
    var curentUserRole = store.getters.getUserRole
    var role = customRole || curentUserRole
    if (role == null || role === undefined) {
        return []
    }
    if (curentUserRole === config.role.inspector && customRole) {
        var dealerDetails = router.options.routes.find(route => {
            return route.name === 'dealerDetails'
        })
        dealerDetails.children.forEach(route => {
            if (!route.meta) {
            } else if (route.meta.inMenu !== undefined && !route.meta.inMenu) {
            } else {
                menu.push(route)
            }
        })
        return menu
    }

    //FIXME: Have to create a normal menu building 
    if (role === config.role.operator) {
        const routes = router.options.routes;

        return [
            routes.find(r => r.name === 'dealers'),
            routes.find(r => r.name === 'kkm'),
            routes.find(r => r.name === 'tickets'),
            routes.find(r => r.name === 'tasks'),
            routes.find(r => r.name === 'persons'),
            routes.find(r => r.name === 'addressInfo')
        ];
    }

    if (role === config.role.dealer) {
        return [
            router.options.routes.find(r => r.name === 'cabinet')
        ]
    }
    
    router.options.routes.forEach(route => {
        if (!route.meta) {
        } else if (route.meta.inMenu !== undefined && !route.meta.inMenu) {
        } else if ((route.meta.admin && role === config.role.admin) ||
            (route.meta.dealer && role === config.role.dealer) || (route.meta.inspector && role === config.role.inspector) ||
            (route.meta.operator && role === config.role.operator)) {
            menu.push(route)
        }
    })

    return menu;
}

export default router
